import api from "../../../common/dependencies/utils/Api";
import {
  GET_A_MENTOR_FORM,
  LOGIN_DATA,
  FACEBOOK_LOGIN,
  TWITTER_VALIDATE_TOKEN,
  STARTUP_INDIA_LOGIN,
  LOGIN_STARTUP_INDIA_DATA,
} from "../../../common/constants/ApplicationUrl";
import { isEmpty } from 'lodash';
import { storage } from '../../../common/dependencies/store/stoarage';
import {
  isLoading
} from '../../.././common/constants/actionConstants';
import { toast } from "react-toastify";

import swal from 'sweetalert';

export const LoginService = {
  getLoginServiceData(params) {
      //
      return api.POST(LOGIN_DATA, params)
      .then((response) => {
        //
          const { data, status } = response || {};
          if (status === 200) {
            let { access_token, refresh_token } = data.authResponseDTO
            // alert('T hank you for contacting us');
            if (status && !isEmpty(data)) {
              
              // storage.setUser({ ...data, ...{ access_token, refresh_token } });
            }
            localStorage.setItem("loggedIn",true);
           localStorage.setItem("SavedLoggedInData",JSON.stringify(data))
           
            return response ;
        } else {
          //
            // dispatch(isLoading(false));
            swal("Retry Login", "Invalid Username or1 Password", 
            "error",
            {closeOnClickOutside: false}
    );
            // toast.error("Invalid Username or Password");
            return { status: false }
        }
         
      }).catch(e => {
          return Promise.reject(e);
      });
    // return api
    //   .POST(LOGIN_DATA, params)
    //   .then((response) => {
    //     const { data: { responseCode, data } = {} } = response;
    //     if (responseCode === 200) {
    //       //
    //       return data;
    //     } else {
    //       return Promise.reject(response);
    //     }
    //   })
    //   .catch((e) => {
    //     return Promise.reject(e);
    //   });
  },
  
  validatetwitter(auth_token,auth_verifier){
    return api
    .GET(`${TWITTER_VALIDATE_TOKEN}oauth_token=`+auth_token+`&oauth_verifier=`+auth_verifier)
    .then((response) => {
      
      if (response) {
        return response;
      } else {
        swal("Retry Login", " Authentication Failed", "error", {
          closeOnClickOutside: false,
        });
        return Promise.reject(response);
      }
    })
    .catch((e) => {
      swal("Retry Login", " Authentication Failed", "error", {
        closeOnClickOutside: false,
      });
      return Promise.reject(e);
    });

  },
  ValidateStartupIndiaLogin(params) {
    return api
      .POST(`${STARTUP_INDIA_LOGIN}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
};

export const ValidateFacebookLogin = {
  validateFacebookLogin(params) {
    return api
      .POST(`${FACEBOOK_LOGIN}`,params)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  }
};
// export const ValidateStartupIndiaLogin = {
//   // validateFacebookLogin(params) {
//     return api
//       .POST(`${STARTUP_INDIA_LOGIN}`,params)
//       .then((response) => {
//         const { data: { responseCode, data } = {} } = response;
//         if (responseCode === 200) {
//           return data;
//         } else {
//           return Promise.reject(response);
//         }
//       })
//       .catch((e) => {
//         return Promise.reject(e);
//       });
//   // }
// };

